import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, Empty, Slider, Button, Table, Space } from 'antd';
import moment from "moment";
import { PlusOutlined } from '@ant-design/icons';
import PlayerTimeline from '../player/PlayerTimeline';
import PlaylistRenderer from '../player/renderers/PlaylistRenderer';
import CodexPlayerHelper from '../player/CodexPlayerHelper';
import "./ScreenBrightnessPage.css";
import CreateBrightnesssSchedulePopup from './CreateBrightnesssSchedulePopup';
import BrightnessScheduler from '../BrightnessScheduler';

const IconSlider = (props) => {
    const formatter = (value) => `${value}%`;
    const { max, min, disabled = false } = props;
    const [value, setValue] = useState(100);
    const mid = Number(((max - min) / 2).toFixed(5));
    const preColorCls = value >= mid ? '' : 'icon-wrapper-active';
    const nextColorCls = value >= mid ? 'icon-wrapper-active' : '';
    return (
        <div className="icon-wrapper">
            <img src="/cms/assets/svgs/icons/brightness_0_icon.svg" className={preColorCls} style={{ width: "30px", height: "30px", margin: "0 20px" }} />
            <Slider tooltip={{ formatter }} disabled={disabled} {...props} onChange={setValue} defaultValue={100} value={value} style={{ width: "50% !important" }} />
            <img src="/cms/assets/svgs/icons/brightness_100_icon.svg" className={nextColorCls} style={{ width: "30px", height: "30px", margin: "0 20px" }} />
        </div>
    );
};


class ScreenBrightnessPage extends React.Component {
    state = {
        previewPlaylistVisible: false,
        previewPlaylistData: null,
        scheduleDatas: [],
        showCreateSchedule: false
    };


    constructor(props) {
        super(props);

        console.log("ScreenBrightnessPage")

        this.previewTimelineRef = React.createRef();
    }

    showPreviewPlaylist = (data = null, doShow = true) => {
        // console.log("data " + JSON.stringify(data))
        return new Promise((resolve, reject) => {
            this.setState({ previewPlaylistData: data, previewPlaylistVisible: doShow }, () => { resolve() });
        })
    }

    stopPreviewPlaylist = () => {
        if (this.previewTimelineRef.current)
            this.previewTimelineRef.current.stopTimer();
        this.showPreviewPlaylist(null, false);
    }


    launchCreateSchedule = () => {
        this.setState({ showCreateSchedule: true, selectedSchedule: null })
    }

    //callthis function to preview playlist
    previewPlaylist = (playlistData, mediaDatas) => {
        const data = CodexPlayerHelper.generatePlaylistReadable(playlistData, mediaDatas);

        this.showPreviewPlaylist(data, true).then(() => {
            if (this.previewTimelineRef.current) {
                this.previewTimelineRef.current.resetTimer();
                this.previewTimelineRef.current.startTimer(data);
            }
        })
    }

    onBrightnessUpdated = () => {
        console.log("Brightness Updated")
    }

    render() {
        const { data } = this.props;
        return (
            <Row justify="space-around" align="middle" >
                <Col style={{ width: "700px", padding: "20px" }}>
                    <div style={{ fontSize: 28, fontWeight: 400, lineHeight: "42px", width: "100%", margin: "0 0 30px 0" }}>
                        Screen Brightness Manager
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 200, lineHeight: "16px", width: "250px", color: "#aaa", margin: "0 0 30px 0" }}>
                        Default Brightness
                    </div>
                    <IconSlider min={0} max={100} disabled></IconSlider>
                    <div style={{ fontSize: 18, fontWeight: 200, lineHeight: "16px", width: "250px", color: "#aaa", margin: "0 0 30px 0", marginTop: "24px" }}>
                        Scheduled Brightness
                    </div>
                    <div>
                        <BrightnessScheduler onSaved={this.onBrightnessUpdated} data={data}></BrightnessScheduler>
                    </div>

                </Col>
            </Row>
        )
    }
}

export default ScreenBrightnessPage